import { Component, OnDestroy, OnInit } from '@angular/core';
import { getOnBehalfUsersSelector } from '../store/state/selectors/matchboard.selectors';
import { Store } from '@ngrx/store';
import { MatchBoardState } from '../store/state/reducers/matchboard.reducers';
import { initApplicationSelector } from '../store/Application/ApplicationSelector';
import { ApplicationState } from '../store/Application/ApplicationReducer';
import { ServerConfig } from '../models/ServerConfig';
import { EnvironmentType } from '../models/EnvironmentType';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
})
export class HomeComponent implements OnInit, OnDestroy {
  onBehalfUsers: any[];

  user: any;
  config: ServerConfig;
  EnvironmentType = EnvironmentType;

  constructor(
    private readonly applicationStore: Store<ApplicationState>,
    private readonly store: Store<MatchBoardState>,
  ) {}

  ngOnDestroy(): void {
    console.debug('i am useless :)');
  }

  ngOnInit() {
    this.applicationStore
      .select(initApplicationSelector)
      .subscribe((config) => {
        this.config = config;
      });
    this.store.select(getOnBehalfUsersSelector).subscribe((onBehalfUsers) => {
      this.onBehalfUsers = onBehalfUsers;
    });
  }
}
